var m = require('mithril');
var prop = require('mithril/stream')
var flash = require('../../components/flash');
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var buttonElement = require('../../components/button');


var enumerationTemplateModal = {};
enumerationTemplateModal.errors = [];
var incompleteOptionError = 'Enumeration template options need both Show and As values';

function normalizeInput(value) {
  return value == null ? '' : String(value).trim();
}

function hasCompleteOption(option) {
  return !!(
    option &&
    normalizeInput(option.name) &&
    normalizeInput(option.id)
  );
}

function hasIncompleteOption(options) {
  return (options || []).some(function (option) {
    return !hasCompleteOption(option);
  });
}

modal.once('closed', function() {
  key.deleteScope('modal');
  key.setScope('home');
});


enumerationTemplateModal.editDialogue = function(record, enumeration, options) {
  enumerationTemplateModal.errors = [];
  enumerationTemplateModal.form = {};
  enumerationTemplateModal.form.options = prop([]);
  if (record && record['@rid']) {
    enumerationTemplateModal.form['@rid'] = prop(record['@rid']);
    enumerationTemplateModal.form.name = prop(record.name);
    if(record.options && Array.isArray(record.options)) {
      enumerationTemplateModal.form.options(record.options.map((option, idx) => { return {name: Object.keys(option)[0], id: option[Object.keys(option)[0]]}}));
    }
  } else {
    enumerationTemplateModal.form.name = prop('');
    enumerationTemplateModal.form.options(enumeration);
  }
  
  var submit = function() {
    var templateName = normalizeInput(enumerationTemplateModal.form.name());
    var templateOptions = enumerationTemplateModal.form.options() || [];

    if (!templateName) {
      enumerationTemplateModal.errors = ['Add a template name'];
      m.redraw();
      return;
    }

    if (!templateOptions.length) {
      enumerationTemplateModal.errors = ['Add at least one enumeration template option'];
      m.redraw();
      return;
    }

    if (hasIncompleteOption(templateOptions)) {
      enumerationTemplateModal.errors = [incompleteOptionError];
      m.redraw();
      return;
    }

    let body = {
      name: templateName,
      options: templateOptions.map(option => {
        const { name, id } = option;
        return { [normalizeInput(name)]: normalizeInput(id) };
      })
    }

    return loaders.requestWithLoader({
      method: enumerationTemplateModal.form['@rid'] ?  'PUT' : 'POST',
      url: `/api/v1/enumeration${enumerationTemplateModal.form['@rid'] ? `/${enumerationTemplateModal.form['@rid']().slice(1)}` : ''}`,
      body
    }).then(response=>{
      key.unbind('enter');
      modal.vm.close();
      options && options.submitCallback ? options.submitCallback() : '';
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(record ? "Edit Enumeration Template" : "Add Enumeration Template");
  modal.vm.body = view;
  modal.vm.buttons([
    {
      label: "Save",
      class: "dib",
      func: submit
    }
  ])

  modal.vm.open()
};



function view() {
  return m('div',[
    m(flash, {items:enumerationTemplateModal.errors, bg: 'bg-red'}),
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => enumerationTemplateModal.form.name(ev.target.value),
      value: enumerationTemplateModal.form.name(),
    }),
    m('div', {class:'form-group'}, [
      m('div.f3.pv2', 'Options'),
      m('table.w-100.pt2.pb3', [
        m('thead', [
          m('tr', [
            m('th.tc.v-btm.fw2.bw1.ph2', [
              m('p.ma0.tc', 'Show')
            ]),
            m('th.tc.v-btm.fw2.bw1.ph2', [
              m('p.ma0.tc', 'As')
            ]),
          ])
        ]),
        m('tbody', {style:{background: '#111111'}}, [
          enumerationTemplateModal.form.options().map((option, idx) => {
            return m('tr', [
              m('td.tc.bb-0.bl-0.bw1', [
                m('input.form-control', {
                  id:'id-input', 
                  type:'text',
                  style: {background: 'inherit'},
                  oninput: function(ev){ option.id = ev.target.value; },
                  value: option.id,
                })
              ]),
              m('td.tc.bb-0.bl-0.bw1', [
                m('input.form-control', {
                  id:'name-input', 
                  type:'text', 
                  style: {background: 'inherit'},
                  oninput: function(ev){ option.name = ev.target.value; },
                  value: option.name,
                })
              ]),
              m('td.br-0.bb-0.bl-0.bw1.w3', [
                m(buttonElement, {
                  class: 'w3 fr',
                  label: m('i.f4.ion-ios-trash.red'), 
                  func: function() {
                    enumerationTemplateModal.form.options().splice(idx, 1)
                  }
                }),
              ])
            ])
          }),
          m('tr', {style: {background: '#111111'}}, [
            m('td'),
            m('td'),
            m('td', [
              m(buttonElement, {
                class: 'w3 fr',
                label: m('i.ion-plus.blue'), 
                func: function() {
                  enumerationTemplateModal.form.options().push({
                    name: '', 
                    id: enumerationTemplateModal.form.options().length == 0 ? 1 : enumerationTemplateModal.form.options()[enumerationTemplateModal.form.options().length - 1].id + 1
                  })
                }
              })
            ])
          ])     
        ])
      ])
    ]),
  ])
}

module.exports = enumerationTemplateModal;
